import { render, staticRenderFns } from "./AdminLogs.vue?vue&type=template&id=60ddf3dc&"
import script from "./AdminLogs.vue?vue&type=script&lang=js&"
export * from "./AdminLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports